import React from 'react';
import PropTypes from 'prop-types';

/** Small summary box of the Sistem Kullanımı / Eğitim panels ("3 / 8 Şu An Çevrimiçi"). */
export const PanelTile = ({ icon: Icon, iconClass = 'tw-text-sky-500', value, of, title, alert }) => (
  <div className={`tw-flex tw-min-w-0 tw-items-center tw-gap-3 tw-rounded-2xl tw-border tw-p-3.5 ${alert ? 'tw-border-rose-500/30 tw-bg-rose-500/[0.06] dark:tw-border-rose-400/25' : 'tw-border-slate-200/80 tw-bg-white/70 dark:tw-border-white/10 dark:tw-bg-white/[0.03]'}`}>
    <Icon aria-hidden="true" className={`tw-h-5 tw-w-5 tw-shrink-0 ${alert ? 'tw-text-rose-500' : iconClass}`} />
    <div className="tw-min-w-0">
      <p className="tw-text-lg tw-font-bold tw-leading-tight tw-tabular-nums tw-text-slate-900 dark:tw-text-white">
        {value}
        {of !== undefined && <small className="tw-text-xs tw-font-medium tw-text-slate-500 dark:tw-text-slate-400"> / {of}</small>}
      </p>
      <p className="tw-truncate tw-text-xs tw-text-slate-500 dark:tw-text-slate-400">{title}</p>
    </div>
  </div>
);

PanelTile.propTypes = {
  icon: PropTypes.elementType.isRequired,
  iconClass: PropTypes.string,
  value: PropTypes.node.isRequired,
  of: PropTypes.node,
  title: PropTypes.string.isRequired,
  alert: PropTypes.bool,
};

export default PanelTile;
